//import logo from './logo.svg';
import './App.css';

import Header from './components/auth/Header';
import Home from './components/pages/Home'
import About from "./components/pages/About"
import Shop from "./components/pages/Shop"
import Contact from "./components/pages/Contact"
import Footer from './components/auth/Footer'

import { Routes, Route } from "react-router-dom";






function App() {
  return (
    <div className="all-web">
 <Header/>
<Routes>

        <Route path="" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="shop" element={<Shop />} />
        <Route path="contact" element={<Contact />} />
      </Routes>
     

<Footer/>

      
    </div>
  );
}

export default App;
